// extracted by mini-css-extract-plugin
export default {"drawer":"ListOfTaxonomyModule_drawer__TNubT"};